import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { createPostageUser } from '../services/api';

function PostageUsersUpload() {
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState('');

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!file) {
            setError('No file selected');
            return;
        }

        try {
            setIsUploading(true);
            setError('');
            const reader = new FileReader();
            reader.onload = async (e) => {
                const users = JSON.parse(e.target.result);
                for (const user of users) {
                    await createPostageUser(user);
                }
                alert('All users uploaded successfully');
            };
            reader.readAsText(file);
        } catch (err) {
            setError('Failed to upload users: ' + err.message);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="container mt-3">
            <h1>Upload Postage Users</h1>
            {error && <div className="alert alert-danger">{error}</div>}
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Select User JSON File</Form.Label>
                    <Form.Control type="file" onChange={handleFileChange} />
                </Form.Group>
                <Button variant="primary" type="submit" disabled={isUploading}>
                    Upload Users
                </Button>
            </Form>
        </div>
    );
}

export default PostageUsersUpload;
